export function DiscoverTradeIdeasGraphic() {
  return (
    <svg
      width='331'
      height='227'
      viewBox='0 0 331 227'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M33.0047 70.4858H228.418C234.082 70.4858 238.684 75.0827 238.684 80.7523V214.383H22.7383V80.7523C22.7383 75.0827 27.3407 70.4858 33.0047 70.4858Z'
        fill='#D9D9D9'
        stroke='#3C3C3C'
        strokeWidth='0.795791'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect x='27.418' y='75.6667' width='222.014' height='144.738' rx='7.35958' fill='white' />
      <g clipPath='url(#clip0_19176_198303)'>
        <rect x='27.418' y='75.6672' width='196.912' height='144.738' fill='white' />
        <rect x='27.418' y='75.6672' width='196.912' height='23.5621' fill='#424244' />
        <circle cx='37.5184' cy='87.4483' r='3.36601' fill='white' />
        <circle cx='47.616' cy='87.4483' r='3.36601' fill='white' />
        <circle cx='57.7137' cy='87.4483' r='3.36601' fill='white' />
        <rect
          x='82.1172'
          y='84.0823'
          width='88.3578'
          height='6.73202'
          rx='3.36601'
          fill='#A7A4A9'
        />
        <rect x='105.68' y='111.01' width='88.3578' height='6.73202' rx='3.36601' fill='#ECECEC' />
        <rect
          x='188.988'
          y='112.693'
          width='3.36601'
          height='3.36601'
          rx='1.68301'
          fill='#4D4651'
        />
        <rect x='107.363' y='112.693' width='36.1846' height='3.36601' rx='1.68301' fill='white' />
        <rect x='27.418' y='99.2292' width='47.9657' height='121.176' fill='#EAEAEC' />
        <rect x='34.1523' y='111.01' width='6.73202' height='6.73202' rx='3.36601' fill='#424244' />
        <rect x='42.5703' y='111.01' width='26.0866' height='6.73202' rx='3.36601' fill='#D9D8DB' />
        <rect
          x='34.1523'
          y='132.889'
          width='34.5016'
          height='5.04902'
          rx='1.68301'
          fill='#D9D8DB'
        />
        <rect x='105.68' y='187.587' width='48.8072' height='5.04902' rx='1.68301' fill='#EBEBEB' />
        <rect
          x='34.1523'
          y='141.305'
          width='16.8301'
          height='5.04902'
          rx='1.68301'
          fill='#D9D8DB'
        />
        <rect x='105.68' y='196.002' width='31.9771' height='5.04902' rx='1.68301' fill='#EBEBEB' />
        <rect x='34.1523' y='149.72' width='26.0866' height='5.04902' rx='1.68301' fill='#D9D8DB' />
        <rect
          x='34.1523'
          y='158.134'
          width='21.8791'
          height='5.04902'
          rx='1.68301'
          fill='#D9D8DB'
        />
        <rect x='34.1523' y='166.55' width='32.8186' height='5.04902' rx='1.68301' fill='#D9D8DB' />
        <rect x='105.68' y='164.867' width='10.098' height='9.25653' rx='1.68301' fill='#EBEBEB' />
        <rect x='120.824' y='139.621' width='10.098' height='34.5016' rx='1.68301' fill='#EBEBEB' />
        <rect x='135.973' y='131.206' width='10.098' height='42.9166' rx='1.68301' fill='#EBEBEB' />
        <rect x='151.125' y='156.451' width='10.098' height='17.6716' rx='1.68301' fill='#EBEBEB' />
        <rect x='166.266' y='148.037' width='10.098' height='26.0866' rx='1.68301' fill='#EBEBEB' />
        <rect x='181.414' y='131.206' width='10.098' height='42.9166' rx='1.68301' fill='#EBEBEB' />
      </g>
      <path
        d='M1.27344 215.811C1.27344 215.022 1.91266 214.383 2.70752 214.383H258.73C259.519 214.383 260.164 215.022 260.164 215.817V216.367C260.164 221.02 256.39 224.794 251.737 224.794H9.69449C5.04207 224.794 1.27344 221.02 1.27344 216.367V215.817V215.811Z'
        fill='#D9D9D9'
        stroke='#3C3C3C'
        strokeWidth='0.795791'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <g filter='url(#filter0_dddd_19176_198303)'>
        <g clipPath='url(#clip1_19176_198303)'>
          <rect
            x='141.141'
            y='26.2717'
            width='148.185'
            height='96.6066'
            rx='4.59487'
            fill='white'
          />
          <path
            d='M173.339 92.9612H162.388C160.804 92.9612 159.52 94.2426 159.52 95.8233C159.52 97.404 160.804 98.6855 162.388 98.6855H173.339C174.924 98.6855 176.208 97.404 176.208 95.8233C176.208 94.2426 174.924 92.9612 173.339 92.9612Z'
            fill='#424244'
          />
          <path
            d='M220.765 67.1602H160.973C160.185 67.1602 159.547 67.798 159.547 68.5863C159.547 69.3747 160.185 70.0125 160.973 70.0125H220.769C221.557 70.0125 222.195 69.3747 222.195 68.5863C222.195 67.798 221.557 67.1602 220.769 67.1602H220.765Z'
            fill='#EBEBEB'
          />
          <path
            d='M207.505 73.1892H160.973C160.185 73.1892 159.547 73.827 159.547 74.6154C159.547 75.4037 160.185 76.0415 160.973 76.0415H207.505C208.294 76.0415 208.932 75.4037 208.932 74.6154C208.932 73.827 208.294 73.1892 207.505 73.1892Z'
            fill='#EBEBEB'
          />
          <path
            d='M183.17 79.3257H160.973C160.185 79.3257 159.547 79.9635 159.547 80.7518C159.547 81.5402 160.185 82.178 160.973 82.178H183.17C183.958 82.178 184.596 81.5402 184.596 80.7518C184.596 79.9635 183.958 79.3257 183.17 79.3257Z'
            fill='#EBEBEB'
          />
          <rect
            x='159.523'
            y='61.4758'
            width='31.1106'
            height='2.84907'
            rx='1.14872'
            fill='#EBEBEB'
          />
          <rect
            x='159.52'
            y='37.7588'
            width='62.0308'
            height='19.5282'
            rx='2.29744'
            fill='#EBEBEB'
          />
          <g clipPath='url(#clip2_19176_198303)'>
            <path
              d='M220.406 76.9174L222.14 75.0483C222.242 74.9386 222.42 74.9539 222.502 75.0794L224.255 77.7798C224.269 77.8005 224.279 77.8232 224.285 77.8471L225.964 84.31C226.025 84.545 226.361 84.5369 226.411 84.2993L228.132 76.0861C228.14 76.0453 228.16 76.0076 228.188 75.977L229.959 74.0689C230.03 73.9921 230.144 73.9732 230.236 74.0229L231.754 74.8409C231.886 74.912 232.05 74.8398 232.086 74.6943L233.758 68.0022C233.813 67.7791 234.126 67.7672 234.199 67.9853L235.737 72.6056C235.797 72.7858 236.038 72.8195 236.145 72.6627L237.791 70.2553C237.809 70.2287 237.833 70.2063 237.86 70.1894L239.499 69.1799C239.627 69.1009 239.796 69.1648 239.839 69.3091L241.688 75.428L243.575 83.7091C243.602 83.8266 243.715 83.9035 243.834 83.8851L245.337 83.6537C245.46 83.6348 245.575 83.7168 245.598 83.8388L247.293 92.9739C247.338 93.2182 247.685 93.2266 247.742 92.9848L249.303 86.377C249.349 86.1802 249.609 86.1351 249.719 86.3047L251.115 88.4539C251.217 88.6115 251.455 88.5863 251.522 88.4108L253.289 83.7869C253.294 83.7748 253.299 83.7632 253.306 83.752L254.964 80.943C255.066 80.7707 255.324 80.8018 255.382 80.9934L257.054 86.5289C257.104 86.6952 257.314 86.7478 257.437 86.6249L259.071 84.9893C259.09 84.9701 259.113 84.9545 259.137 84.9431L260.839 84.157C260.949 84.1062 261.08 84.1496 261.137 84.2563L262.811 87.349C262.888 87.4902 263.082 87.5115 263.187 87.39L264.889 85.4246C264.899 85.413 264.91 85.4024 264.922 85.393L266.621 84.0851C266.735 83.9978 266.899 84.0343 266.965 84.1612L268.647 87.3977C268.713 87.5246 268.877 87.5611 268.991 87.4738L270.598 86.2367C270.666 86.1845 270.757 86.1743 270.834 86.2101L272.491 86.9756C272.582 87.0173 272.688 86.9961 272.756 86.9232L274.552 84.988C274.569 84.9697 274.583 84.9486 274.593 84.9257L276.512 80.641L278.44 76.0389C278.445 76.0288 278.448 76.0184 278.451 76.0078L280.376 68.5983C280.38 68.5839 280.385 68.5699 280.391 68.5564L282.176 64.8472C282.244 64.7045 282.433 64.6724 282.545 64.7844L284.205 66.446C284.235 66.4757 284.256 66.513 284.266 66.5537L286.185 74.3854L287.972 80.576C288.028 80.7696 288.289 80.8026 288.391 80.6291L290.055 77.811'
              stroke='#C6C6C7'
              strokeWidth='1.14872'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        </g>
        <rect
          x='140.744'
          y='25.8754'
          width='148.977'
          height='97.3992'
          rx='4.99118'
          stroke='#ECECEC'
          strokeWidth='0.792615'
        />
      </g>
      <g filter='url(#filter1_dddddd_19176_198303)'>
        <rect
          x='208.918'
          y='1'
          width='105.896'
          height='69.0373'
          rx='4.59487'
          fill='white'
          shapeRendering='crispEdges'
        />
        <rect
          x='208.522'
          y='0.603692'
          width='106.689'
          height='69.8299'
          rx='4.99118'
          stroke='#ECECEC'
          strokeWidth='0.792615'
          shapeRendering='crispEdges'
        />
        <path
          d='M306.593 58.4358H295.642C294.058 58.4358 292.773 59.7172 292.773 61.2979C292.773 62.8786 294.058 64.1601 295.642 64.1601H306.593C308.177 64.1601 309.462 62.8786 309.462 61.2979C309.462 59.7172 308.177 58.4358 306.593 58.4358Z'
          fill='#424244'
        />
        <path
          d='M285.918 58.4358H274.966C273.382 58.4358 272.098 59.7172 272.098 61.2979C272.098 62.8786 273.382 64.1601 274.966 64.1601H285.918C287.502 64.1601 288.786 62.8786 288.786 61.2979C288.786 59.7172 287.502 58.4358 285.918 58.4358Z'
          fill='#C6C6C7'
        />
        <rect
          x='227.176'
          y='46.4004'
          width='0.989087'
          height='12.0964'
          rx='0.494544'
          fill='#C6C6C7'
        />
        <rect
          x='226.191'
          y='46.8569'
          width='2.96726'
          height='7.98821'
          rx='1.48363'
          fill='#C6C6C7'
        />
        <rect
          x='231.086'
          y='23.3491'
          width='0.989087'
          height='23.2799'
          rx='0.494544'
          fill='#C6C6C7'
        />
        <rect x='230.09' y='23.3491' width='2.96726' height='23.2799' rx='1.48363' fill='#C6C6C7' />
        <rect
          x='234.988'
          y='22.436'
          width='0.989087'
          height='9.81409'
          rx='0.494544'
          fill='#ECECEC'
        />
        <rect x='234' y='23.5781' width='2.96726' height='6.84704' rx='1.48363' fill='#ECECEC' />
        <rect
          x='238.887'
          y='19.2419'
          width='0.989087'
          height='10.727'
          rx='0.494544'
          fill='#C6C6C7'
        />
        <rect x='237.902' y='19.469' width='2.96726' height='10.4988' rx='1.48363' fill='#C6C6C7' />
        <rect
          x='242.797'
          y='19.2419'
          width='0.989087'
          height='8.21645'
          rx='0.494544'
          fill='#ECECEC'
        />
        <rect
          x='241.801'
          y='19.2419'
          width='2.96726'
          height='1.82588'
          rx='0.912939'
          fill='#ECECEC'
        />
        <rect
          x='246.699'
          y='5.7749'
          width='0.989087'
          height='22.8235'
          rx='0.494544'
          fill='#ECECEC'
        />
        <rect
          x='245.711'
          y='21.5232'
          width='2.96726'
          height='6.84704'
          rx='1.48363'
          fill='#ECECEC'
        />
        <rect
          x='250.605'
          y='20.8379'
          width='0.989087'
          height='8.21645'
          rx='0.494544'
          fill='#C6C6C7'
        />
        <rect
          x='249.613'
          y='25.8599'
          width='2.96726'
          height='2.28235'
          rx='1.14117'
          fill='#C6C6C7'
        />
        <rect
          x='254.512'
          y='15.3621'
          width='0.989087'
          height='12.0964'
          rx='0.494544'
          fill='#ECECEC'
        />
        <rect x='253.52' y='23.3491' width='2.96726' height='2.51058' rx='1.25529' fill='#ECECEC' />
        <rect
          x='258.41'
          y='20.8379'
          width='0.989087'
          height='10.727'
          rx='0.494544'
          fill='#ECECEC'
        />
        <rect
          x='257.422'
          y='27.4561'
          width='2.96726'
          height='2.05411'
          rx='1.02706'
          fill='#ECECEC'
        />
        <rect
          x='262.316'
          y='24.7178'
          width='0.989087'
          height='5.47763'
          rx='0.494544'
          fill='#C6C6C7'
        />
        <rect
          x='261.328'
          y='28.3696'
          width='2.96726'
          height='1.82588'
          rx='0.912939'
          fill='#C6C6C7'
        />
        <rect
          x='266.223'
          y='25.6309'
          width='0.989087'
          height='9.58586'
          rx='0.494544'
          fill='#ECECEC'
        />
        <rect x='265.23' y='28.8257' width='2.96726' height='2.96705' rx='1.48353' fill='#ECECEC' />
        <rect
          x='270.125'
          y='26.7722'
          width='0.989087'
          height='13.6941'
          rx='0.494544'
          fill='#ECECEC'
        />
        <rect
          x='269.137'
          y='32.2512'
          width='2.96726'
          height='7.07528'
          rx='1.48363'
          fill='#ECECEC'
        />
        <rect
          x='274.023'
          y='27.9126'
          width='0.989087'
          height='10.0423'
          rx='0.494544'
          fill='#C6C6C7'
        />
        <rect x='273.035' y='31.7947' width='2.96726' height='5.9341' rx='1.48363' fill='#C6C6C7' />
        <rect
          x='277.934'
          y='30.4238'
          width='0.989087'
          height='12.5529'
          rx='0.494544'
          fill='#ECECEC'
        />
        <rect
          x='276.945'
          y='31.7947'
          width='2.96726'
          height='11.1835'
          rx='1.48363'
          fill='#ECECEC'
        />
        <rect
          x='281.836'
          y='33.8491'
          width='0.989087'
          height='12.0964'
          rx='0.494544'
          fill='#ECECEC'
        />
        <rect
          x='280.852'
          y='42.7495'
          width='2.96726'
          height='2.28235'
          rx='1.14117'
          fill='#ECECEC'
        />
        <rect
          x='285.746'
          y='29.7385'
          width='0.989087'
          height='19.8564'
          rx='0.494544'
          fill='#C6C6C7'
        />
        <rect
          x='284.758'
          y='32.7083'
          width='2.96726'
          height='14.1506'
          rx='1.48363'
          fill='#C6C6C7'
        />
        <rect
          x='289.645'
          y='35.4456'
          width='0.989087'
          height='6.39057'
          rx='0.494544'
          fill='#ECECEC'
        />
        <rect
          x='288.656'
          y='37.2717'
          width='2.96726'
          height='1.82588'
          rx='0.912939'
          fill='#ECECEC'
        />
        <rect
          x='293.551'
          y='32.0239'
          width='0.989087'
          height='11.1835'
          rx='0.494544'
          fill='#C6C6C7'
        />
        <rect
          x='292.562'
          y='32.2512'
          width='2.96726'
          height='8.90115'
          rx='1.48363'
          fill='#C6C6C7'
        />
        <rect
          x='297.453'
          y='23.5781'
          width='0.989087'
          height='18.2588'
          rx='0.494544'
          fill='#ECECEC'
        />
        <rect
          x='296.469'
          y='32.2512'
          width='2.96726'
          height='9.12938'
          rx='1.48363'
          fill='#ECECEC'
        />
      </g>
      <path
        d='M262.487 98.73H221.58C216.309 98.73 212.035 103.035 212.035 108.346V216.189C212.035 221.5 216.309 225.805 221.58 225.805H262.487C267.758 225.805 272.032 221.5 272.032 216.189V108.346C272.032 103.035 267.758 98.73 262.487 98.73Z'
        fill='#C3C3C3'
        stroke='#424244'
        strokeWidth='0.795791'
        strokeMiterlimit='10'
      />
      <path
        d='M212.379 123.115C212.379 122.735 212.074 122.428 211.697 122.428C211.321 122.428 211.016 122.735 211.016 123.115V127.923C211.016 128.302 211.321 128.61 211.697 128.61C212.074 128.61 212.379 128.302 212.379 127.923V123.115Z'
        fill='#424244'
      />
      <path
        d='M212.379 133.419C212.379 133.039 212.074 132.732 211.697 132.732C211.321 132.732 211.016 133.039 211.016 133.419V141.662C211.016 142.041 211.321 142.348 211.697 142.348C212.074 142.348 212.379 142.041 212.379 141.662V133.419Z'
        fill='#424244'
      />
      <path
        d='M212.379 145.782C212.379 145.403 212.074 145.095 211.697 145.095C211.321 145.095 211.016 145.403 211.016 145.782V154.025C211.016 154.404 211.321 154.712 211.697 154.712C212.074 154.712 212.379 154.404 212.379 154.025V145.782Z'
        fill='#424244'
      />
      <path
        d='M273.055 139.601C273.055 139.221 272.75 138.914 272.373 138.914C271.997 138.914 271.691 139.221 271.691 139.601V154.712C271.691 155.092 271.997 155.399 272.373 155.399C272.75 155.399 273.055 155.092 273.055 154.712V139.601Z'
        fill='#424244'
      />
      <path
        d='M263.053 99.6716H222.146C217.628 99.6716 213.965 103.362 213.965 107.914V215.757C213.965 220.309 217.628 223.999 222.146 223.999H263.053C267.572 223.999 271.234 220.309 271.234 215.757V107.914C271.234 103.362 267.572 99.6716 263.053 99.6716Z'
        fill='white'
        stroke='#424244'
        strokeWidth='0.795791'
        strokeMiterlimit='10'
      />
      <circle cx='242.233' cy='126.359' r='9.18974' fill='#EBEBEB' />
      <path
        d='M240.172 168.582H224.784C222.558 168.582 220.754 170.396 220.754 172.634C220.754 174.871 222.558 176.685 224.784 176.685H240.172C242.398 176.685 244.202 174.871 244.202 172.634C244.202 170.396 242.398 168.582 240.172 168.582Z'
        fill='#424244'
      />
      <path
        d='M248.504 102.164H235.55C234.232 102.164 233.164 103.24 233.164 104.568C233.164 105.896 234.232 106.972 235.55 106.972H248.504C249.822 106.972 250.89 105.896 250.89 104.568C250.89 103.24 249.822 102.164 248.504 102.164Z'
        fill='#424244'
        stroke='#424244'
        strokeWidth='0.680814'
        strokeMiterlimit='10'
      />
      <path
        d='M248.516 105.942C249.269 105.942 249.879 105.327 249.879 104.568C249.879 103.81 249.269 103.195 248.516 103.195C247.763 103.195 247.152 103.81 247.152 104.568C247.152 105.327 247.763 105.942 248.516 105.942Z'
        fill='white'
      />
      <rect x='220.449' y='155.948' width='17.5074' height='1.59158' rx='0.795791' fill='#EBEBEB' />
      <rect x='220.449' y='151.969' width='32.6274' height='1.59158' rx='0.795791' fill='#EBEBEB' />
      <rect x='220.449' y='147.99' width='42.9727' height='1.59158' rx='0.795791' fill='#EBEBEB' />
      <rect x='220.562' y='144.738' width='16.0821' height='1.59672' rx='0.798359' fill='#EBEBEB' />
      <defs>
        <filter
          id='filter0_dddd_19176_198303'
          x='132.693'
          y='25.479'
          width='165.08'
          height='121.157'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='7.65509'
            operator='erode'
            in='SourceAlpha'
            result='effect1_dropShadow_19176_198303'
          />
          <feOffset dy='15.3102' />
          <feGaussianBlur stdDeviation='7.65509' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_19176_198303'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='1.43533'
            operator='erode'
            in='SourceAlpha'
            result='effect2_dropShadow_19176_198303'
          />
          <feOffset dy='2.87066' />
          <feGaussianBlur stdDeviation='1.43533' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_19176_198303'
            result='effect2_dropShadow_19176_198303'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='0.717665'
            operator='erode'
            in='SourceAlpha'
            result='effect3_dropShadow_19176_198303'
          />
          <feOffset dy='1.43533' />
          <feGaussianBlur stdDeviation='0.717665' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect2_dropShadow_19176_198303'
            result='effect3_dropShadow_19176_198303'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='0.239222'
            operator='erode'
            in='SourceAlpha'
            result='effect4_dropShadow_19176_198303'
          />
          <feOffset dy='0.478443' />
          <feGaussianBlur stdDeviation='0.239222' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect3_dropShadow_19176_198303'
            result='effect4_dropShadow_19176_198303'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect4_dropShadow_19176_198303'
            result='shape'
          />
        </filter>
        <filter
          id='filter1_dddddd_19176_198303'
          x='192.815'
          y='0.207275'
          width='138.101'
          height='116.553'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='15.3102'
            operator='erode'
            in='SourceAlpha'
            result='effect1_dropShadow_19176_198303'
          />
          <feOffset dy='30.6204' />
          <feGaussianBlur stdDeviation='15.3102' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_19176_198303'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='7.65509'
            operator='erode'
            in='SourceAlpha'
            result='effect2_dropShadow_19176_198303'
          />
          <feOffset dy='15.3102' />
          <feGaussianBlur stdDeviation='7.65509' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_19176_198303'
            result='effect2_dropShadow_19176_198303'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='2.87066'
            operator='erode'
            in='SourceAlpha'
            result='effect3_dropShadow_19176_198303'
          />
          <feOffset dy='5.74132' />
          <feGaussianBlur stdDeviation='2.87066' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect2_dropShadow_19176_198303'
            result='effect3_dropShadow_19176_198303'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='1.43533'
            operator='erode'
            in='SourceAlpha'
            result='effect4_dropShadow_19176_198303'
          />
          <feOffset dy='2.87066' />
          <feGaussianBlur stdDeviation='1.43533' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect3_dropShadow_19176_198303'
            result='effect4_dropShadow_19176_198303'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='0.717665'
            operator='erode'
            in='SourceAlpha'
            result='effect5_dropShadow_19176_198303'
          />
          <feOffset dy='1.43533' />
          <feGaussianBlur stdDeviation='0.717665' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect4_dropShadow_19176_198303'
            result='effect5_dropShadow_19176_198303'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='0.239222'
            operator='erode'
            in='SourceAlpha'
            result='effect6_dropShadow_19176_198303'
          />
          <feOffset dy='0.478443' />
          <feGaussianBlur stdDeviation='0.239222' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect5_dropShadow_19176_198303'
            result='effect6_dropShadow_19176_198303'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect6_dropShadow_19176_198303'
            result='shape'
          />
        </filter>
        <clipPath id='clip0_19176_198303'>
          <rect x='27.418' y='75.667' width='196.912' height='144.738' rx='5.04902' fill='white' />
        </clipPath>
        <clipPath id='clip1_19176_198303'>
          <rect
            x='141.141'
            y='26.2717'
            width='148.185'
            height='96.6066'
            rx='4.59487'
            fill='white'
          />
        </clipPath>
        <clipPath id='clip2_19176_198303'>
          <rect
            width='183.795'
            height='91.8974'
            fill='white'
            transform='translate(220.406 2.14844)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
